export function getTransformOrigin(placement) {
  const [sideKey, alignKey] = placement.split("-");
  const align = alignKey === "start" ? "0" : alignKey === "end" ? "100%" : "50%";
  const sides = {
    top: `${align} 100%`,
    right: `0% ${align}`,
    bottom: `${align} 0%`,
    left: `100% ${align}`
  };
  return sides[sideKey];
}